module.exports = __webpack_public_path__ + "img/image (14).05dd67c5.jpg";